var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('vue-recaptcha',{ref:"recaptcha",attrs:{"sitekey":_vm.site_key,"loadRecaptchaScript":true,"size":"invisible","see":_vm.site_key},on:{"verify":_vm.onVerify}})}
var staticRenderFns = []

export { render, staticRenderFns }